<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img style="height: 120px;width: auto;" src="@/assets/img/hezhongLogo_bg.png" alt="logo图">
    </div>
    <!-- <p class="title">四川合众齐云科技有限公司</p> -->
    <p class="address_tel_fax">
      <span>公司地址：成都一环路南二段1号</span>
      <span>Tel：028-8543-3681</span>
    </p>
    <p class="email_wx">
      <span>邮箱：zhou@hezhong-qiyun.com</span>
      <!-- <span>微信号：xxx</span> -->
    </p>
    <p class="copy">Copyright &copy; 2016 - {{ new Date().getFullYear() }} 四川合众齐云科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 312px;
  height: 114px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 20px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue